import { AuthenticationContextValuesImpl } from './AuthenticationContextValues'
import { ALL_SCOPES } from '../constants'

const parseMockScopes = (envValue: string = '') =>
  new Set(
    envValue
      .split(',')
      .map(scope => scope.trim())
      .filter(Boolean)
  )

const getScopes = (): string[] => {
  const finalScopes = new Set(ALL_SCOPES)

  if (import.meta.env.VITE_AUTH_MOCK_REMOVE_SCOPES?.trim()) {
    const denied = parseMockScopes(import.meta.env.VITE_AUTH_MOCK_REMOVE_SCOPES)
    for (const scope of denied) {
      finalScopes.delete(scope)
    }
  }

  if (import.meta.env.VITE_AUTH_MOCK_ADD_SCOPES?.trim()) {
    const allowed = parseMockScopes(import.meta.env.VITE_AUTH_MOCK_ADD_SCOPES)
    for (const scope of allowed) {
      finalScopes.add(scope)
    }
  }

  return Array.from(finalScopes)
}

export const mockAuthContextValues: AuthenticationContextValuesImpl = new AuthenticationContextValuesImpl(undefined, getScopes())

export const overrideUserScopes = (scopes: string[]) => {
  mockAuthContextValues.setTestScopeOverrides(scopes)
}

export const clearUserScopeOverrides = () => {
  mockAuthContextValues.clearTestScopeOverrides()
}
